// extracted by mini-css-extract-plugin
export default {"pagination":"paginado_pagination__PrTVg","noActive":"paginado_noActive__NL2z8"};